import { useNavigate } from 'react-router-dom';
import { RoutePaths } from 'constants/RoutePaths';
import { useAuthContext } from 'hooks/useAuthContext';
import { useGetMyProfilePhoto } from 'hooks/useGetMyProfilePhoto';
import { setAccessTokenGetter } from 'api/config/axios';
import { ITokenResponse } from '@api/models/response/ITokenResponse';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';

export const useHandleLoginSuccess = () => {
    const navigate = useNavigate();
    const { userDispatch } = useAuthContext();
    const { getMyProfilePhotoUrl } = useGetMyProfilePhoto();
    const { enqueueSnackbar } = useSnackbar();
    const { t } = useTranslation();

    const handleLoginSuccess = async (data: ITokenResponse) => {
        setAccessTokenGetter(() => data.token || '');
        const photoUrl = await getMyProfilePhotoUrl();
        const profile = data.profile;
        profile.selectedWorkspace.userPhotoUrl = photoUrl;
        userDispatch({ type: 'LOGIN_SUCCESS', payload: { ...profile, token: data.token } });
        navigate(RoutePaths.HOME);
        enqueueSnackbar(t('login.success'), { variant: 'success' });
    };

    return { handleLoginSuccess };
};